"use strict";
/**
 * Markets Cache
 * Centralized caching for market and event data
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearAllCaches = clearAllCaches;
exports.isKalshiCacheFresh = isKalshiCacheFresh;
exports.isPolymarketCacheFresh = isPolymarketCacheFresh;
exports.isPolymarketUsCacheFresh = isPolymarketUsCacheFresh;
exports.getKalshiEventCache = getKalshiEventCache;
exports.setKalshiEventCache = setKalshiEventCache;
exports.getKalshiMarketCache = getKalshiMarketCache;
exports.setKalshiMarketCache = setKalshiMarketCache;
exports.appendKalshiMarketCache = appendKalshiMarketCache;
exports.getPolymarketEventCache = getPolymarketEventCache;
exports.setPolymarketEventCache = setPolymarketEventCache;
exports.getPolymarketCacheTimestamp = getPolymarketCacheTimestamp;
exports.getPolymarketUsEventCache = getPolymarketUsEventCache;
exports.setPolymarketUsEventCache = setPolymarketUsEventCache;
exports.getPolymarketUsCacheTimestamp = getPolymarketUsCacheTimestamp;
exports.getNovigEventCache = getNovigEventCache;
exports.setNovigEventCache = setNovigEventCache;
exports.isNovigCacheFresh = isNovigCacheFresh;
exports.getCachedEventMarkets = getCachedEventMarkets;
exports.setCachedEventMarkets = setCachedEventMarkets;
exports.deleteCachedEventMarkets = deleteCachedEventMarkets;
exports.getCurrentCategory = getCurrentCategory;
exports.setCurrentCategory = setCurrentCategory;
const constants_1 = require("./constants");
// Kalshi caches
let eventCache = [];
let marketCache = [];
let lastCacheTime = 0;
let currentCategory = "sports";
// Market-by-event cache: eventId → StateMarket[]
let eventMarketCache = new Map();
// Polymarket caches
let polymarketEventCache = [];
let polymarketEventCacheTimestamp = 0;
let polymarketUsEventCache = [];
let polymarketUsEventCacheTimestamp = 0;
// Novig cache
let novigEventCache = [];
let novigEventCacheTimestamp = 0;
/**
 * Clear all market caches
 */
function clearAllCaches() {
    eventCache = [];
    marketCache = [];
    lastCacheTime = 0;
    eventMarketCache.clear();
    polymarketEventCache = [];
    polymarketEventCacheTimestamp = 0;
    polymarketUsEventCache = [];
    polymarketUsEventCacheTimestamp = 0;
    novigEventCache = [];
    novigEventCacheTimestamp = 0;
}
/**
 * Check if Kalshi cache is fresh
 */
function isKalshiCacheFresh() {
    return Date.now() - lastCacheTime < constants_1.MARKET_CACHE_DURATION;
}
/**
 * Check if Polymarket cache is fresh
 */
function isPolymarketCacheFresh() {
    return Date.now() - polymarketEventCacheTimestamp < constants_1.MARKET_CACHE_DURATION;
}
/**
 * Check if Polymarket US cache is fresh
 */
function isPolymarketUsCacheFresh() {
    return (Date.now() - polymarketUsEventCacheTimestamp < constants_1.MARKET_CACHE_DURATION);
}
// Kalshi cache getters/setters
function getKalshiEventCache() {
    return [...eventCache];
}
function setKalshiEventCache(events) {
    eventCache = events;
    lastCacheTime = Date.now();
}
function getKalshiMarketCache() {
    return [...marketCache];
}
function setKalshiMarketCache(markets) {
    marketCache = markets;
    lastCacheTime = Date.now();
}
function appendKalshiMarketCache(markets) {
    marketCache = [...marketCache, ...markets];
    lastCacheTime = Date.now();
}
// Polymarket cache getters/setters
function getPolymarketEventCache() {
    return polymarketEventCache;
}
function setPolymarketEventCache(events) {
    polymarketEventCache = events;
    polymarketEventCacheTimestamp = Date.now();
}
function getPolymarketCacheTimestamp() {
    return polymarketEventCacheTimestamp;
}
// Polymarket US cache getters/setters
function getPolymarketUsEventCache() {
    return polymarketUsEventCache;
}
function setPolymarketUsEventCache(events) {
    polymarketUsEventCache = events;
    polymarketUsEventCacheTimestamp = Date.now();
}
function getPolymarketUsCacheTimestamp() {
    return polymarketUsEventCacheTimestamp;
}
// Novig cache getters/setters
function getNovigEventCache() {
    return novigEventCache;
}
function setNovigEventCache(events) {
    novigEventCache = events;
    novigEventCacheTimestamp = Date.now();
}
function isNovigCacheFresh() {
    return Date.now() - novigEventCacheTimestamp < constants_1.MARKET_CACHE_DURATION;
}
// Event market cache
function getCachedEventMarkets(eventId) {
    return eventMarketCache.get(eventId);
}
function setCachedEventMarkets(eventId, markets) {
    eventMarketCache.set(eventId, {
        markets,
        timestamp: Date.now(),
    });
}
function deleteCachedEventMarkets(eventId) {
    eventMarketCache.delete(eventId);
}
// Current category
function getCurrentCategory() {
    return currentCategory;
}
function setCurrentCategory(category) {
    currentCategory = category;
}
